import React, { useEffect } from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { refreshTrueFitWidget } from 'utilities/truefit/truefit';
import styles from './TrueFitWidget.module.css';

interface TrueFitWidgetProps {
  itemNumber: string;
  colour: string;
  locale: string;
  userId: string;
}

function TrueFitWidget({ itemNumber, colour, locale, userId }: TrueFitWidgetProps) {
  const { selectedOptions } = useSelectedSkuContext();
  const { colour: selectedColour } = selectedOptions;

  useEffect(() => {
    if (selectedColour || userId) {
      refreshTrueFitWidget();
    }
  }, [selectedColour, userId]);

  return (
    <div
      className={[styles.container, 'tfc-fitrec-product'].filter(Boolean).join(' ')}
      data-styleid={itemNumber}
      data-userid={userId}
      data-colorid={selectedColour || colour}
      data-locale={locale}
      data-testid="truefit_widget_container"
    />
  );
}

export default TrueFitWidget;
